import * as React from 'react';
import { ModalProps } from 'antd/es/modal';
import { useState } from 'react';
import t from 'utils/translations';
import { ConfirmationModal } from 'components/pages/grouplistpage/actionmenu/DeleteGroupModal';
import styled from 'styled-components';
import theme from 'theme';
import { message } from 'antd';
import { apiDeleteCategory } from 'api/categories';

const InfoText = styled.p`
    && {
        color: ${theme.colors.gray_dark};
        font-size: 14px;
        margin-left: 15px;
    }
`;

interface Props extends ModalProps {
    afterSuccess: () => void;
    categoryId: string;
    closeModal: () => void;
    name: string;
    numberOfGroupsInCategory: number;
}

function DeleteCategoryModal({
    afterSuccess,
    categoryId,
    closeModal,
    name,
    numberOfGroupsInCategory,
    visible
}: Props) {
    const [isLoading, setIsLoading] = useState(false);

    function handleCancel() {
        closeModal();
    }

    function handleOk() {
        setIsLoading(true);
        apiDeleteCategory(categoryId)
            .then(res => {
                if (res.status === 200) {
                    message.success(t('CATEGORY_DELETE_SUCCESS'));
                    setIsLoading(false);
                    afterSuccess();
                    closeModal();
                }
            })
            .catch(() => {
                message.error(t('CATEGORY_DELETE_FAIL'));
                setIsLoading(false);
            });
    }

    return (
        <ConfirmationModal
            cancelText={t('CANCEL_MODAL')}
            confirmLoading={isLoading}
            destroyOnClose={true}
            onCancel={() => handleCancel()}
            onOk={() => handleOk()}
            okText={t('DELETE_CATEGORY')}
            title={t('DELETE_CATEGORY_MODAL_TITLE')}
            visible={visible}
        >
            <>
                <p>{`${t('DELETE_CATEGORY_CONFIRM')} "${name}"?`}</p>
                <InfoText>{`${t(
                    'DELETE_CATEGORY_INFO_PART1'
                )} ${numberOfGroupsInCategory} ${t(
                    'DELETE_CATEGORY_INFO_PART2'
                )}`}</InfoText>
            </>
        </ConfirmationModal>
    );
}

export default DeleteCategoryModal;
